import React from 'react';
import './EntryName.less';

export const EntryName = ({text, isExpanded}) => {
	return <span className={`entry-name ${isExpanded ? 'entry-name--expanded' : ''}`}>{text}</span>;
};
